export default "__VITE_ASSET__C25QyTRC__"